export default __webpack_public_path__ + "static/media/maria_dimitriadou.24e02d2d.png";